import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { StaticContentService, StaticContent } from '../../services/static-content.service';

@Component({
  selector: 'app-static-content',
  standalone: false,
  templateUrl: './static-content.component.html',
  styleUrls: ['./static-content.component.scss']
})
export class StaticContentComponent implements OnInit {
  content: StaticContent | null = null;
  loading = true;
  error: string | null = null;
  contentType: string = '';

  constructor(
    private route: ActivatedRoute,
    private staticContentService: StaticContentService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.contentType = params['type'];
      this.loadContent();
    });
  }

  private loadContent(): void {
    this.loading = true;
    this.error = null;
    
    this.staticContentService.getStaticContentByType(this.contentType).subscribe({
      next: (content: StaticContent | null) => {
        if (content) {
          this.content = content;
        } else {
          this.error = 'Content not found';
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.error = 'Failed to load content. Please try again later.';
        this.loading = false;
        console.error('Error loading static content:', err);
      }
    });
  }

  getPageTitle(): string {
    if (this.content?.title) {
      return this.content.title;
    }
    
    // Fallback titles based on content type
    switch (this.contentType.toLowerCase()) {
      case 'terms': return 'Terms and Conditions';
      case 'privacy': return 'Privacy Policy';
      case 'about': return 'About Us';
      case 'contact': return 'Contact Us';
      case 'faq': return 'Frequently Asked Questions';
      default: return 'Information';
    }
  }

  goBack(): void {
    this.location.back();
  }
}
